import { Component, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { AriaLabels } from '@maced/angular-components/lib/global-header/global-header.model';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';
import { Menu } from '@maced/angular-components/lib/navigation-drawer/menubar/menubar.model';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { delay, of } from 'rxjs';

@Component({
  selector: 'app-global-header',
  templateUrl: './global-header.component.html'
})
export class GlobalHeaderComponent {
  closeUrl = "/button";
  iconMenu = "icon-menu";
  iconPlus = "icon-plus";
  colorNames = ["primary", "secondary"];
  title = 'Heading 1';
  titleSpanish = 'encabezado 1';
  titleHindi = 'शीर्षक 1';

  subTitle = 'Overline';
  subTitleSpanish = 'Superposición 1';
  subTitleHindi = 'ओवरलाइन 1';

  backUrl = '/global-header';
  logoUrl = '/';
  logo = '../../assets/images/logo-mee-black-mac.svg';
  smallLogo = '../../assets/images/logo.svg';

  logoAltText = 'Macmillan Education Everywhere Platform';
  logoAltTextSpanish = 'Plataforma Educación en todas partes de Macmillan';
  logoAltTextHindi = 'मैकमिलन एजुकेशन एवरीवेयर प्लेटफॉर्म';

  moreMenuTitle = 'More';
  moreMenuTitleSpanish = 'más';
  moreMenuTitleHindi = 'अधिक';

  callToAction = '/global-header';

  ariaLabels: AriaLabels = {
    backButtonAriaLabel: "Back",
    closeButtonAriaLabel: "Close",
    hamburgerAriaLabel: "Menu",
    logoIcon: "Logo"
  };
  ariaLabelsHindi: AriaLabels = {
    backButtonAriaLabel: "पीछे",
    closeButtonAriaLabel: "बंदकरे",
    hamburgerAriaLabel: "अधिक",
    logoIcon: "प्रतीक चिन्ह"
  };
  ariaLabelsSpanish: AriaLabels = {
    backButtonAriaLabel: "atrás",
    closeButtonAriaLabel: "Cerca",
    hamburgerAriaLabel: "Más",
    logoIcon: "Logo"
  };

  options: DropdownOption[] = [
    {
      id: 'option1',
      name: 'option1',
      label: '100%',
      url: '/global-header'
    },
    {
      id: 'option2',
      name: 'option2',
      label: '200%',
      url: '/global-header'
    },
    {
      id: 'option3',
      name: 'option3',
      label: '400%',
      url: '/global-header'
    }
  ];

  selectedOptions = this.options[0];
  buttonType = 'button' as string;
  buttonId = 'hamburgerIcon' as string;
  buttonValue = 'hamburger' as string;
  currentUrl: string;
  activeMenuBar = false as boolean;
  activeHamburger = false as boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId: any,
    private route: ActivatedRoute,
    private router: Router,
    private elementRef: ElementRef
  ) {
    this.currentUrl = this.router.url.split('?')[0];
    this.buttonType = isPlatformBrowser(platformId) ? 'button' : 'link';
    this.route.queryParams.subscribe(params => {
      if (!isPlatformBrowser(platformId)) {
        this.noJSOpenMenu(params.type, params.hasHamburger);
      }       
      if((params.globalHeaderId+ 'HamburgerIcon') === document.activeElement?.id && params.navbar === 'open'){
        of('Observable To Update HTML').pipe(delay(100)).subscribe(() => {
        let focusElement: any = this.elementRef.nativeElement.querySelector('#'+params.globalHeaderId+ 'CloseIcon');
        focusElement?.focus();
        })
      }
    });
  }

  openMenu(value: string) {
    if (value === 'multiButton') {
      if (!this.activeMenuBar) {
        this.activeMenuBar = true;
      } else {
        this.activeMenuBar = false;
      }
    } else {
      if (!this.activeHamburger) {
        this.activeHamburger = true;
      } else {
        this.activeHamburger = false;
      }
    }
  }

  noJSOpenMenu(type: string, hasHamburger: number) {
    if (type === 'multiButton') {
      if (hasHamburger == 1)
        this.activeMenuBar = true;
      else
        this.activeMenuBar = false;
    } else {
      if (hasHamburger == 1)
        this.activeHamburger = true;
      else
        this.activeHamburger = false;
    }
  }

}